// Third party imports
import { createSlice } from "@reduxjs/toolkit";

/**
 * Cards of the linked board currently open (Account / Grafici / Strategist).
 * `loading` is true only until the first answer for a board: later polls are silent.
 */
export const linkedBoardSlice = createSlice({
  name: "linkedBoard",
  initialState: {
    boardId: null,
    cards: [],
    loading: false,
  },
  reducers: {
    // Switching board: drop the previous board's cards and show the loader once.
    startBoard: (state, action) => {
      state.boardId = action.payload;
      state.cards = [];
      state.loading = true;
    },
    setCards: (state, action) => {
      state.cards = action.payload;
    },
    // Merges into a card already on the board; ignores cards that left it (e.g. moved away by someone else).
    updateCard: (state, action) => {
      const index = state.cards.findIndex((card) => card.id === action.payload.id);
      if (index !== -1) {
        state.cards[index] = { ...state.cards[index], ...action.payload };
      }
    },
    // Adds a card (creation) or replaces it when already present.
    upsertCard: (state, action) => {
      const index = state.cards.findIndex((card) => card.id === action.payload.id);
      if (index !== -1) {
        state.cards[index] = action.payload;
      } else {
        state.cards.push(action.payload);
      }
    },
    removeCard: (state, action) => {
      state.cards = state.cards.filter((card) => card.id !== action.payload);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { startBoard, setCards, updateCard, upsertCard, removeCard, setLoading } =
  linkedBoardSlice.actions;
export default linkedBoardSlice.reducer;
